<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Adquira seu Dr.Achei Card</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <sin-saude-planos></sin-saude-planos>
    </div>
  </div>
</template>
<script>
import SinSaudePlanos from '@/components/shared/SinSaudePlanos'

export default {
  components: {
    SinSaudePlanos
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdquirirSinSaude.vue